import { render, staticRenderFns } from "./BarHomeKabupaten.vue?vue&type=template&id=4a1496d7"
import script from "./BarHomeKabupaten.vue?vue&type=script&lang=js"
export * from "./BarHomeKabupaten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports